import { Component } from '@angular/core';
import { BaseConfirmationDialogComponent } from '../../../../lib/components/dialogs/base-confirmation-dialog.component';

@Component({
  selector: 'boi-applicant-order-warning-dialog',
  templateUrl: './applicant-order-warning-dialog.component.html',
  styleUrls: ['./applicant-order-warning-dialog.component.scss']
})
export class ApplicantOrderWarningDialogComponent extends BaseConfirmationDialogComponent<void> {}
